real.infiniteScroll = (function ($, real) {
    'use strict';

    const defaultOptions = {
        scrollElement: real.dom.$window, // In which element the scroll event is used to detect when to load more
        pxFromBottomToTriggerLoadMore: 150, // How many pixels away from bottom of scrollElement triggers load more
        url: null, // Which url is used for loading list items
        successFn: null, // Which function is called when more items are loaded
        getUrlDataFn: null // A function to be called to append data to url request (including next page requests)
    };

    const initInfiniteScroll = function (infiniteScroll, options) {
        infiniteScroll.addClass('real-infinite-scroll-initialized');

        if (!options) {
            options = {};
        }
        options = $.extend({}, defaultOptions, options);

        if (options.url === null) {
            throw new Error('You need to give "url" in real.infiniteScroll.init options.');
        }

        if (options.getNextPageUrlFromResponse === null) {
            throw new Error('You need to give "getNextPageUrlFromResponse" in real.infiniteScroll.init options.');
        }

        if (options.successFn === null) {
            throw new Error('You need to give "successFn" function in real.infiniteScroll.init options.');
        }

        infiniteScroll.data('real-infinite-scroll-options', options);

        options.loadMoreFn = function () {
            if (infiniteScroll.data('real-infinite-scroll-loading-more') === true) {
                // Infinite scroll is already loading more.
                return;
            }

            if (infiniteScroll.data('real-infinite-scroll-is-paused') === true) {
                // Infinite scroll is paused.
                return;
            }

            if (!infiniteScroll.is('.real-infinite-scroll-initialized')) {
                // Infinite scroll has been destroyed.
                return;
            }

            infiniteScroll.dataAndAttr('real-infinite-scroll-loading-more', true);

            let data = null;
            if (typeof options.getUrlDataFn === 'function') {
                data = options.getUrlDataFn();
            }

            const ajax = real.ajax.json(options.url, {
                type: 'GET',
                data: data,
                success: function (response) {
                    infiniteScroll.dataAndAttr('real-infinite-scroll-loading-more', false);

                    if (!infiniteScroll.is('.real-infinite-scroll-initialized')) {
                        // Infinite scroll has been destroyed.
                        return;
                    }

                    const nextPageUrl = options.getNextPageUrlFromResponse(response);
                    if (nextPageUrl) {
                        options.url = nextPageUrl;
                        requestAnimationFrame(() => {
                            options.scrollElement.trigger('scroll');
                        });
                    } else {
                        infiniteScroll.dataAndAttr('real-infinite-scroll-all-loaded', true);
                    }

                    options.successFn(response);
                },
                complete: () => {
                    infiniteScroll.removeData('real-infinite-scroll-ajax');
                },
                showErrorNotification: response => {
                    if (typeof options.showErrorNotification === 'boolean') {
                        return options.showErrorNotification;
                    }
                    if (typeof options.showErrorNotification === 'function') {
                        return options.showErrorNotification(response);
                    }
                    return true;
                },
                logError: response => {
                    if (typeof options.logError === 'boolean') {
                        return options.logError;
                    }
                    if (typeof options.logError === 'function') {
                        return options.logError(response);
                    }
                    return true;
                },
                error: response => {
                    if (typeof options.errorFn === 'function') {
                        options.errorFn(response);
                    }
                }
            });
            infiniteScroll.data('real-infinite-scroll-ajax', ajax);
        };

        options.scrollFn = function (e) {
            if (infiniteScroll.data('real-infinite-scroll-all-loaded') === true) {
                // All items are loaded, remove the scroll function.
                options.scrollElement.off('scroll', scroll);
                return;
            }

            if (infiniteScroll.data('real-infinite-scroll-loading-more') === true) {
                // Infinite scroll is already loading more.
                return;
            }

            if (infiniteScroll.data('real-infinite-scroll-is-paused') === true) {
                // Infinite scroll is paused.
                return;
            }

            if (!infiniteScroll.is('.real-infinite-scroll-initialized')) {
                // Infinite scroll has been destroyed.
                return;
            }

            if (infiniteScroll.is('.velocity-animating')) {
                // Infinite scroll is animating.
                return;
            }

            if (infiniteScroll.is(':hidden')) {
                // Infinite scroll is hidden.
                return;
            }

            const currentScroll = options.scrollElement.scrollTop() + options.scrollElement.outerHeight();
            let maxScroll;

            if (options.scrollElement[0] === real.dom.$window[0]) {
                maxScroll = infiniteScroll.height() + infiniteScroll.offset().top;
            } else {
                maxScroll = options.scrollElement[0].scrollHeight;
            }

            if (currentScroll > maxScroll - options.pxFromBottomToTriggerLoadMore) {
                // Load more.
                options.loadMoreFn();
            }
        };

        options.scrollElement.on('scroll', options.scrollFn);

        // Call loadFn once upon initialization.
        options.loadMoreFn();
    };

    const destroyInfiniteScroll = function (infiniteScroll) {
        infiniteScroll.removeClass('real-infinite-scroll-initialized');

        const ajax = infiniteScroll.data('real-infinite-scroll-ajax');
        if (typeof ajax?.abort === 'function') {
            // Abort the previous ajax request.
            ajax.abort();
            infiniteScroll.removeData('real-infinite-scroll-ajax');
        }

        const options = infiniteScroll.data('real-infinite-scroll-options');
        options?.scrollElement.off('scroll', options.scrollFn);

        infiniteScroll.removeData('real-infinite-scroll-options');
        infiniteScroll.removeDataAndAttr('real-infinite-scroll-is-paused');

        infiniteScroll.removeDataAndAttr('real-infinite-scroll-loading-more');
        infiniteScroll.removeDataAndAttr('real-infinite-scroll-all-loaded');
    };

    return {
        init: function (elem, options) {
            elem.findIncludingSelf('.real-infinite-scroll:not(.real-infinite-scroll-initialized)').each(function () {
                initInfiniteScroll($(this), options);
            });
        },

        destroy: function (elem) {
            elem.findIncludingSelf('.real-infinite-scroll.real-infinite-scroll-initialized').each(function () {
                destroyInfiniteScroll($(this));
            });
        },

        pause: function (elem) {
            elem.findIncludingSelf('.real-infinite-scroll.real-infinite-scroll-initialized').each(function () {
                $(this).dataAndAttr('real-infinite-scroll-is-paused', true);
            });
        },

        resume: function (elem) {
            elem.findIncludingSelf('.real-infinite-scroll.real-infinite-scroll-initialized').each(function () {
                const loopInfiniteScroll = $(this);

                if (loopInfiniteScroll.data('real-infinite-scroll-is-paused') !== true) {
                    // Infinite scroller was not paused, no need to resume
                    return;
                }

                loopInfiniteScroll.dataAndAttr('real-infinite-scroll-is-paused', false);

                const options = loopInfiniteScroll.data('real-infinite-scroll-options');
                options.scrollElement.trigger('scroll');
            });
        }
    };

})(jQuery, real);
